export const initialState = {
  data: {
    email: "",
    otp: "",
  },
};
